<div class="dropdown-teleport">
  <ng-container teleportOutlet="dropdown"></ng-container>
</div>
